import { render, staticRenderFns } from "./RateTaxPersonTable.vue?vue&type=template&id=3067211a&scoped=true&"
import script from "./RateTaxPersonTable.vue?vue&type=script&lang=js&"
export * from "./RateTaxPersonTable.vue?vue&type=script&lang=js&"
import style0 from "./RateTaxPersonTable.vue?vue&type=style&index=0&id=3067211a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067211a",
  null
  
)

component.options.__file = "RateTaxPersonTable.vue"
export default component.exports